import {
  SupplierContactsListingGetters,
  SupplierContactsListingActions,
  SupplierContactsListingMutations
} from '@/app/features/supplier-contacts/features/supplier-contacts-listing/supplier-contacts-listing.keys';
import { supplierContactsListingService } from '@/app/features/supplier-contacts/features/supplier-contacts-listing/supplier-contacts-listing.service';
import { TolErrorsActions } from '@/app/features/tol-errors/tol-errors.keys';
import i18n from '@/i18n';

export const getInitialState = () => {
  return {
    supplierContacts: [],
    supplierContactsRecordCount: 0,
    supplierContactsSortOrder: {
      sortBy: 'display_name',
      sortDirection: 'asc'
    },
    supplierContactsPaginationParameters: {
      recordsPerPage: 10,
      offset: 0
    },
    supplierContactsActiveInactive: 'both',
    supplierContactsSearchParam: ''
  };
};

export const supplierContactsListingStore = {
  state: getInitialState(),
  getters: {
    [SupplierContactsListingGetters.SupplierContactsList]: state => state.supplierContacts,
    [SupplierContactsListingGetters.SortBy]: state => state.supplierContactsSortOrder.sortBy,
    [SupplierContactsListingGetters.SortDirection]: state =>
      state.supplierContactsSortOrder.sortDirection,
    [SupplierContactsListingGetters.SupplierContactsPerPage]: state =>
      state.supplierContactsPaginationParameters.recordsPerPage,
    [SupplierContactsListingGetters.SupplierContactsListingOffset]: state =>
      state.supplierContactsPaginationParameters.offset,
    [SupplierContactsListingGetters.SupplierContactsRecordCount]: state =>
      state.supplierContactsRecordCount,
    [SupplierContactsListingGetters.SupplierContactsActiveInactive]: state =>
      state.supplierContactsActiveInactive,
    [SupplierContactsListingGetters.SupplierContactsSearchParam]: state =>
      state.supplierContactsSearchParam
  },
  mutations: {
    [SupplierContactsListingMutations.SetSupplierContactsList](state, supplierContacts) {
      state.supplierContacts = supplierContacts;
    },
    [SupplierContactsListingMutations.SetSupplierContactsSortOrder](state, sortOrder) {
      state.supplierContactsSortOrder = sortOrder;
    },
    [SupplierContactsListingMutations.SetSupplierContactsPaginationParameters](state, pagination) {
      state.supplierContactsPaginationParameters = pagination;
    },
    [SupplierContactsListingMutations.ResetSupplierContactsPaginationOffset](state) {
      state.supplierContactsPaginationParameters.offset = 0;
    },
    [SupplierContactsListingMutations.SetSupplierContactsRecordCount](state, recordCount) {
      state.supplierContactsRecordCount = recordCount;
    },
    [SupplierContactsListingMutations.SetSupplierContactsActiveInactive](state, activeInactive) {
      state.supplierContactsActiveInactive = activeInactive;
    },
    [SupplierContactsListingMutations.SetSearchParam](state, param) {
      state.supplierContactsSearchParam = param;
    }
  },
  actions: {
    [SupplierContactsListingActions.RetrieveSupplierContacts]({ state, commit, dispatch }) {
      return supplierContactsListingService
        .retrieveSupplierContacts(
          state.supplierContactsActiveInactive,
          state.supplierContactsSortOrder,
          state.supplierContactsPaginationParameters,
          state.supplierContactsSearchParam
        )
        .then(supplierContacts => {
          supplierContacts.map(s => {
            s.displayName = s.last_name + ', ' + s.first_name;
          });
          dispatch(SupplierContactsListingActions.RetrieveSupplierContactsRecordCount);
          commit(SupplierContactsListingMutations.SetSupplierContactsList, supplierContacts);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error,
            message: i18n.t('supplierContacts.listing.errors.retrieveSupplierContacts')
          });
        });
    },
    [SupplierContactsListingActions.SetSupplierContactsSortOrder]({ commit, dispatch }, sortOrder) {
      commit(SupplierContactsListingMutations.SetSupplierContactsSortOrder, sortOrder);
      commit(SupplierContactsListingMutations.ResetSupplierContactsPaginationOffset);
      dispatch(SupplierContactsListingActions.RetrieveSupplierContacts);
    },
    [SupplierContactsListingActions.SetSupplierContactsPaginationParameters](
      { commit, dispatch },
      pagination
    ) {
      commit(SupplierContactsListingMutations.SetSupplierContactsPaginationParameters, pagination);
      dispatch(SupplierContactsListingActions.RetrieveSupplierContacts);
    },
    [SupplierContactsListingActions.ExportSupplierContactsAsExcel]({ state }, downloadPreference) {
      let supplierContactsPaginationParameters = '';
      if (downloadPreference === i18n.t('supplierContacts.listing.actions.exportPage')) {
        supplierContactsPaginationParameters = state.supplierContactsPaginationParameters;
      }
      supplierContactsListingService.downloadSupplierContactsXlsx(
        state.supplierContactsActiveInactive,
        state.supplierContactsSortOrder,
        supplierContactsPaginationParameters
      );
    },
    [SupplierContactsListingActions.SetSupplierContactsActiveInactive](
      { commit, dispatch },
      activeInactive
    ) {
      commit(SupplierContactsListingMutations.SetSupplierContactsActiveInactive, activeInactive);
      dispatch(SupplierContactsListingActions.RetrieveSupplierContacts);
    },
    [SupplierContactsListingActions.RetrieveSupplierContactsRecordCount]: ({
      state,
      commit,
      dispatch
    }) => {
      return supplierContactsListingService
        .retrieveRecordCount(
          state.supplierContactsActiveInactive,
          state.supplierContactsSearchParam
        )
        .then(res => {
          commit(SupplierContactsListingMutations.SetSupplierContactsRecordCount, res);
        })
        .catch(error => {
          dispatch(TolErrorsActions.SetError, {
            error
          });
        });
    },

    [SupplierContactsListingActions.UpdateSupplierContactsList](
      { commit, dispatch },
      searchResults
    ) {
      commit(SupplierContactsListingMutations.SetSearchParam, searchResults.searchParam);
      commit(SupplierContactsListingMutations.ResetSupplierContactsPaginationOffset);
      return dispatch(SupplierContactsListingActions.RetrieveSupplierContactsRecordCount).then(
        () => {
          commit(SupplierContactsListingMutations.SetSupplierContactsList, searchResults.data);
        }
      );
    }
  }
};
